import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pathSegments = pathname.split("/").filter(Boolean);
    const isPortalLesson =
      pathSegments[0] === "portal" &&
      pathSegments[1] === "module" &&
      pathSegments.length >= 4;

    if (isPortalLesson) {
      const lessonsHeader = document.getElementById("lessons-header");
      lessonsHeader?.scrollIntoView({ behavior: "auto", block: "start" });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
